import React from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Input,
  Label,
  Row,
} from "reactstrap";
import { useEffect, useState } from "react";
import { canceLInvoice, getPaymentTypes, getReceivePayment } from "../../util/APIUtils";
import ReceivePaymentBody from "./ReceivePaymentBody";
import InvoiceDetails from "./InvoiceDetails";
import ModalFullscreenExample from "./ModalFullscreenExample";
import swal from "sweetalert";
import { LoadingOverlay } from "../../util/Helpers";
import { ButtonStyles } from "../../constants/ButtonStyles";

export default function ReceivePayment() {
  const [values, setValues] = useState({
    billNumber: "",
  });
  const [block, setBlock] = useState(false);
  const [invDetails, setInvDetails] = useState({});
  const [paymntDetails, setPaymntDetails] = useState([]);
  const [modal, setModal] = useState(false);
  const [hide, setHide] = useState(false);


  const [opts, setOpts] = useState([]);
  useEffect(() => {
    loadOptions();
  }, []);

  const loadOptions = () => {
    getPaymentTypes().then((response) => {
      setOpts(response);
    });
  };

  const onChangeNotesMap = ({ target }) => {
    const { name, value } = target;
    setValues((previousState) => ({
      ...previousState,
      [name]: value,
    }));
  };

  const updateMap = () => {
    const trimmedBillNumber = values.billNumber.trim();
    if (!trimmedBillNumber || trimmedBillNumber.length !== 8) {
      swal({
        text: "Bill Number is required and must be exactly 8 characters long.",
        icon: "warning",
      });
      return;
    }

    setBlock(true);
    getReceivePayment({ ...values, billNumber: trimmedBillNumber })
      .then((response) => {
        setBlock(false);
        setInvDetails(response.invoiceDetails);
        setPaymntDetails(response.paymentDetails);
        // setHide(response.invoiceDetails.status === "NOT_PAID" || response.invoiceDetails.status === "PAID");
        setHide(true);
      })
      .catch((error) => {
        setBlock(false);
        swal({
          text: "Unexpected Error " + error,
          icon: "error",
        });
      });
  };
  const clearAll = (e) => {
    let obj = { billNumber: "" };
    setValues(obj);
    setInvDetails({});
    setPaymntDetails([]);
    setHide(false);
  };

  const collectPayment = (e) => {
    toggle();
  };

  const toggle = () => setModal(!modal);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      updateMap();
    }
  };

  const cancelInvoice = async (obj) => {
    setBlock(true);
    const confirmCancel = await swal({
      text: "Are you sure you want to cancel this invoice?",
      icon: "warning",
      buttons: ["No", "Yes"],
      dangerMode: true,
    });

    if (!confirmCancel) {
      setBlock(false);
      return;
    }
    try {
      await canceLInvoice(obj);
      updateMap();
    } catch (error) {
      swal({ text: `Unexpected Error: ${error.message}` });
    } finally {
      setBlock(false);
    }
  }

  return (
    <div >
      {block && <LoadingOverlay />}
      <Card style={{
        borderRadius: "15px",
        boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
        border: "none",
        overflow: "hidden"
      }}>
        <CardHeader style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          padding: "20px 25px",
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: "none"
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <i className="fa fa-credit-card" style={{ fontSize: "24px", color: "#fff" }}></i>
            <strong style={{ fontSize: '1.2rem', color: "#fff" }}>Receive Payment</strong>
          </div>
        </CardHeader>
        <CardBody style={{ padding: "25px" }}>
          <ModalFullscreenExample
            OnToggle={toggle}
            view={modal}
            currentRow={invDetails}
            options={opts}
            refresh={updateMap}
          />

          <Row className="align-items-center">
            <Col md="12" className="d-flex align-items-center">
              <Label for="billNumber" className="form-control-sm mr-2 mb-0" style={{ whiteSpace: "nowrap", fontWeight: "600", color: "#555" }}>Bill Number</Label>
              <Input
                type="text"
                name="billNumber"
                id="billNumber"
                value={values.billNumber}
                onChange={onChangeNotesMap}
                onKeyPress={handleKeyPress}
                className="form-control-sm"
                style={{ width: "150px", borderRadius: "8px", border: "1px solid #e0e0e0" }}
                autoComplete="off"
              />
              <Button style={{ ...ButtonStyles.primarySm, marginLeft: "10px" }} onClick={updateMap}>
                <i className="fa fa-search" style={{ marginRight: "5px" }} />Search
              </Button>
              <Button style={{ ...ButtonStyles.secondarySm, marginLeft: "10px" }} onClick={clearAll}>
                <i className="fa fa-times" style={{ marginRight: "5px" }} />Clear
              </Button>
              {((invDetails.status === "NOT_PAID" || invDetails.status === "PARTIALLY_PAID") && hide) ? (
                <Button style={{ ...ButtonStyles.successSm, marginLeft: "10px" }} onClick={collectPayment}>
                  <i className="fa fa-check" style={{ marginRight: "5px" }} />Collect Payment
                </Button>) : null}
              {(invDetails.status == "NOT_PAID" && hide) ? (
                <Button style={{ ...ButtonStyles.dangerSm, marginLeft: "10px" }} onClick={cancelInvoice}>
                  <i className="fa fa-ban" style={{ marginRight: "5px" }} />Cancel Invoice
                </Button>) : null}
            </Col>
          </Row>
          <br />
          {Object.keys(invDetails).length !== 0 ? (
            <InvoiceDetails headValues={invDetails} flag={true} />
          ) : null}
        </CardBody>
      </Card>
      <div className="animated fadeIn">
        <ReceivePaymentBody data={paymntDetails} />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/ReceivePayment.js